


































import Vue from 'vue';
import QuoteTemplateNoteTooltipIcon from '../common/QuoteTemplateNoteTooltipIcon.vue';

export default Vue.extend({
  components: { QuoteTemplateNoteTooltipIcon },
  props: {
    paymentTermTemplates: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    headers: [
      {
        text: '',
        align: 'start',
        width: 30,
        sortable: false,
        value: 'note'
      },
      {
        text: '#',
        align: 'center',
        width: 50,
        sortable: false,
        value: 'index'
      },
      {
        text: 'Title',
        align: 'start',
        sortable: false,
        value: 'title'
      },
      {
        text: 'Code',
        align: 'center',
        sortable: false,
        value: 'code'
      },
      {
        sortable: false,
        align: 'end',
        value: 'actions'
      }
    ]
  })
});
